import React, { ComponentType, FC } from 'react';
import styled from 'styled-components';
import { ProductiveHeading01, TextWrapper } from 'ozone/atoms';

interface Props {
  component: ComponentType;
}

const Box = styled.div`
  display: flex;
  height: 200px;
  margin-bottom: ${({ theme }) => theme.spacing.normal};
`;

const Left = styled(TextWrapper)`
  flex: 0 0 75%;
  box-shadow: var(--shadow-04);
`;

const Right = styled.div`
  flex: 1;
  margin-left: ${({ theme }) => theme.spacing.eighth};
  box-shadow: var(--shadow-04);
`;

const Title = styled(ProductiveHeading01).attrs({
  as: TextWrapper,
})``;

export const TypeToken: FC<Props> = ({ component: Wrapper, children }) => (
  <Box>
    <Left>
      <Wrapper>{children}</Wrapper>
    </Left>
    <Right>
      <Title>{Wrapper.displayName}</Title>
    </Right>
  </Box>
);
